module.exports = __webpack_public_path__ + "img/testimonials-3.3d677828.jpg";